import { InjectionToken } from '@angular/core'
import { MetaDefinition } from '@angular/platform-browser'

export const metaTagsToken = new InjectionToken<MetaDefinition[]>(
  'MetaTagsToken',
)
